/**
 * Découpe une réservation en plusieurs blocs selon la vue
 * @param {object} reservation - La réservation à découper
 * @param {boolean} isHalfDay - true pour vue WEEK (demi-journées), false pour vue MONTH (journées)
 * @returns {array} - Liste des blocs de réservation
 */
const splitReservationByPeriod = (reservation, isHalfDay = false) => {
  const { dateDebut, dateFin } = reservation;
  const blocks = [];

  let currentDate = dateDebut.clone().startOf('day');
  const endDate = dateFin.clone().startOf('day');

  while (currentDate.isSameOrBefore(endDate, 'day')) {
    const isStartDay = currentDate.isSame(dateDebut, 'day');
    const isEndDay = currentDate.isSame(dateFin, 'day');

    if (isHalfDay) {
      // Vue WEEK : découpe par demi-journées (matin et après-midi)

      // Bloc du matin (00:00 → 12:00)
      const morningStart = currentDate.clone().startOf('day');
      const morningEnd = currentDate.clone().startOf('day').hour(12).minute(0);

      // Vérifier si la réservation couvre la matinée de ce jour
      const resaStartsBeforeMorningEnd = isStartDay
        ? dateDebut.isBefore(morningEnd)
        : true;
      const resaEndsAfterMorningStart = isEndDay
        ? dateFin.isAfter(morningStart)
        : true;

      if (resaStartsBeforeMorningEnd && resaEndsAfterMorningStart) {
        const blockStart = isStartDay && dateDebut.isAfter(morningStart)
          ? dateDebut
          : morningStart;
        const blockEnd = isEndDay && dateFin.isBefore(morningEnd)
          ? dateFin
          : morningEnd;

        if (blockStart.isBefore(blockEnd)) {
          blocks.push({
            ...reservation,
            dateDebutBlock: blockStart,
            dateFinBlock: blockEnd,
            periodType: 'morning',
          });
        }
      }

      // Bloc de l'après-midi (12:00 → 23:59)
      const afternoonStart = currentDate.clone().startOf('day').hour(12).minute(0);
      const afternoonEnd = currentDate.clone().endOf('day');

      // Vérifier si la réservation couvre l'après-midi de ce jour
      const resaStartsBeforeAfternoonEnd = isStartDay
        ? dateDebut.isBefore(afternoonEnd)
        : true;
      const resaEndsAfterAfternoonStart = isEndDay
        ? dateFin.isAfter(afternoonStart)
        : true;

      if (resaStartsBeforeAfternoonEnd && resaEndsAfterAfternoonStart) {
        const blockStart = isStartDay && dateDebut.isAfter(afternoonStart)
          ? dateDebut
          : afternoonStart;
        const blockEnd = isEndDay && dateFin.isBefore(afternoonEnd)
          ? dateFin
          : afternoonEnd;

        if (blockStart.isBefore(blockEnd)) {
          blocks.push({
            ...reservation,
            dateDebutBlock: blockStart,
            dateFinBlock: blockEnd,
            periodType: 'afternoon',
          });
        }
      }
    } else {
      // Vue MONTH : découpe par journées complètes (00:00 → 23:59)
      const dayStart = currentDate.clone().startOf('day');
      const dayEnd = currentDate.clone().endOf('day');

      // Vérifier si la réservation couvre cette journée
      const resaStartsBeforeDayEnd = isStartDay
        ? dateDebut.isBefore(dayEnd)
        : true;
      const resaEndsAfterDayStart = isEndDay
        ? dateFin.isAfter(dayStart)
        : true;

      if (resaStartsBeforeDayEnd && resaEndsAfterDayStart) {
        const blockStart = isStartDay && dateDebut.isAfter(dayStart)
          ? dateDebut
          : dayStart;
        const blockEnd = isEndDay && dateFin.isBefore(dayEnd)
          ? dateFin
          : dayEnd;

        if (blockStart.isBefore(blockEnd)) {
          blocks.push({
            ...reservation,
            dateDebutBlock: blockStart,
            dateFinBlock: blockEnd,
          });
        }
      }
    }

    currentDate = currentDate.add(1, 'day');
  }

  return blocks;
};

export default splitReservationByPeriod;
